import React from "react";
// types
import { TMainPageLayoutV2 } from "../type";


const MNPG002 = ( props:TMainPageLayoutV2 ) => {
    return null;
}

const Component = React.memo(MNPG002, (prevProps: TMainPageLayoutV2, nextProps: TMainPageLayoutV2) => {
    console.log("MNPG002.memo", { prevProps, nextProps });
    return true;
});

export default Component;
